// Линейка CODE 30/55 — жевательный табак.
// Здесь же лежат данные для страницы /code190, чтобы карточки каталога
// и плитки на странице линейки не расходились.
import code from "../assets/images/code95/code.webp";
import code_2 from "../assets/images/code95/code_2.webp";
import code_3 from "../assets/images/code95/code_3.webp";
import code_4 from "../assets/images/code95/code_4.webp";
import code_fone from "../assets/images/fone/code_fone.svg";
import code_2_fone from "../assets/images/fone/code_2_fone.svg";
import code_3_fone from "../assets/images/fone/code_3_fone.svg";
import code_4_fone from "../assets/images/fone/code_4_fone.svg";

const animations = ["swing-left", "swing-right", "float"];

// fone / rotate используются только плиткой на странице CODE 30/55
export const code55Items = [
  {
    id: "menthol-strong",
    title: "Crispy Mint",
    img: code,
    fone: code_fone,
    rotate: "15deg",
    bg: "#2F8F6F",
  },
  {
    id: "ice-berry",
    title: "Royal Mint",
    img: code_2,
    fone: code_2_fone,
    rotate: "110deg",
    bg: "#3F4E9E",
  },
  {
    id: "mango-mint",
    title: "Fresh Mint",
    img: code_3,
    fone: code_3_fone,
    rotate: "280deg",
    bg: "#4BA88A",
  },
  {
    id: "grapefruit-zest",
    title: "Ice Cool",
    img: code_4,
    fone: code_4_fone,
    rotate: "150deg",
    bg: "#4A8FB8",
  },
];

// Форма карточки каталога: ProductItem ждёт vape / bg / animation
export const code55Products = code55Items.map((it, i) => ({
  id: `c55-${it.id}`,
  title: it.title,
  vape: it.img,
  bg: it.bg,
  animation: animations[i % animations.length],
}));

export default code55Products;
